
import type { FormControl } from "./form-manager";
import { ControllerTag } from "@/utils";

export const controlTag = new ControllerTag<FormControl>('control');

// For use in vanilla JS code that needs access to a control
Object.defineProperty(window, '_wc_controlTag', { value: controlTag, writable: false });